// Material UI
import { makeStyles } from '@material-ui/core';
import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  customButtonSecondaryRoot: { fontSize: '12px', lineHeight: '16px' },
  substitutionButtonIcon: { marginRight: '.5rem' },
  root: {
    display: 'grid',
    gridRowGap: 15,
    gridTemplateColumns: 'auto',
  },
  tooltip: {
    fontSize: '0.75rem',
    backgroundColor: neutral.black,
    padding: '0.5rem',
    fontWeight: 700,
    width: '12.5rem',
  },
}));
